<template>
  <section class="mb-6 mt-3">
    <div class="media mb-3">
      <div class="media-content is-flex is-align-items-center">
        <p>
          <strong style="font-size: large">
            {{ getConflictText(entity.localEntity) }}
          </strong>
        </p>
      </div>
    </div>

    <div class="buttons are-small mb-4">
      <b-button size="is-small" @click="$emit('resolve-all', index, 'local')">
        Use Mine for All
      </b-button>
      <b-button size="is-small" @click="$emit('resolve-all', index, 'server')">
        Use Theirs for All
      </b-button>
    </div>

    <template v-for="(change, key) in entity.differences">
      <FieldResolver
        v-if="shouldDisplayField(index, key)"
        :key="key"
        :index="index"
        :entity="entity"
        :fieldKey="key"
        :change="{ local: change.attempted, server: change.persisted }"
        :resolved="resolution[index]?.[key]"
        :customComponent="customFieldComponents[key]"
        :fieldsWithoutDisplay="fieldsWithoutDisplay"
        :module="module"
        @resolve-field="$emit('resolve-field', ...arguments)"
      />
    </template>
  </section>
</template>

<script>
import { LINKED_FIELDS } from '../../constants/conflict-constants';
import { getConflictText } from '../../utils/conflict-labels';
import { isDeepEqual } from '../../utils/conflict-utils';
import FieldResolver from './FieldResolver';

export default {
  name: 'ConflictItem',
  components: { FieldResolver },
  props: {
    entity: { type: Object, required: true },
    index: { type: Number, required: true },
    resolution: { type: Object, required: true },
    module: { type: String, default: null },
    customFieldComponents: { type: Object, required: true },
    fieldsWithoutDisplay: { type: Array, required: true },
  },
  methods: {
    getConflictText,
    isDeepEqual,
    shouldDisplayField(index, key) {
      const { differences } = this.entity;

      return !Object.keys(LINKED_FIELDS).some((mainKey) => {
        return LINKED_FIELDS[mainKey].includes(key) && differences[mainKey];
      });
    },
  },
};
</script>
